export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    msg: string,
  ) {
    super(msg);
    this.name = 'ApiError';
  }
}

export const ERROR_MESSAGES: Record<string, string> = {
  invalid_api_key: 'The API key is missing or invalid.',
  invalid_input: 'The request body was malformed.',
  internal_error: 'Something went wrong on our end. Try again in a moment.',
  network: 'Could not reach the server. Check your connection and try again.',
};

export function describeApiError(err: unknown): string {
  if (err instanceof ApiError) {
    // invalid_input carries a specific server message ("Invalid URL",
    // "URL must use http or https scheme"); show it instead of the generic text.
    if (err.code === 'invalid_input' && err.message) return err.message;
    return ERROR_MESSAGES[err.code] ?? err.message;
  }
  return ERROR_MESSAGES.network;
}
